const addInstance = (singletons, factory, globalContext) => {
	const instance = factory(globalContext);
	singletons.set(factory, instance);
	return instance;
};

const requestSingleton = factory => globalContext => {
	const { req } = globalContext;
	const { singletons = new Map() } = req;

	req.singletons = singletons;

	return singletons.get(factory) || addInstance(singletons, factory, globalContext);
};

export default requestSingleton;
